import { Injectable } from '@angular/core';
import {CurrentUser} from '../modules/auth/model/CurrentUser';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  // Private property to store setter / getter values
  private _currentUserData: CurrentUser;
  private _loggedInDoctorId: string;
  private _practicingDoctorId: string;
  private _enterpriseId: string;

  constructor() { }

  /* PEOPLE (e.g. Doctors, Users, and Patients)
  *****************************************************************************************************************************************/
  get currentUserData() {
    if (!this._currentUserData) {
      const su = localStorage.getItem('storedUser');
      this._currentUserData = JSON.parse(su) as CurrentUser;
    }

    return this._currentUserData;
  }

  get loggedInDoctorId() {
    if (!this._loggedInDoctorId) {
      const id = localStorage.getItem('loggedInDoctorId');
      if (id) {
        this._loggedInDoctorId = id;
      }
    }
    return this._loggedInDoctorId;
  }

  set loggedInDoctorId(id: string) {
    localStorage.setItem('loggedInDoctorId', id);
    this._loggedInDoctorId = id;
  }

  get practicingDoctorId() {
    if (!this._loggedInDoctorId) {
      const id = localStorage.getItem('practicingDoctorId');
      if (id) {
        this._practicingDoctorId = id;
      }
    }
    return this._practicingDoctorId;
  }

  set practicingDoctorId(id: string) {
    if (id === null) {
      localStorage.removeItem('practicingDoctorId');
      this._practicingDoctorId = id;
    } else {
      localStorage.setItem('practicingDoctorId', id);
      this._practicingDoctorId = id;
    }
  }
  /* END PEOPLE
  * ***************************************************************************************************************************************/

  /* ORGANIZATIONS (e.g. Enterprise, practices, locations, etc)
  *****************************************************************************************************************************************/
  get enterpriseId() {
    if (!this._enterpriseId) {
      this._enterpriseId = localStorage.getItem('TDOEnterpriseId');
    }
    return this._enterpriseId;
  }

  set enterpriseId(id: string) {
    localStorage.setItem('TDOEnterpriseId', id);
    this._enterpriseId = id;
  }
  /* END ORGANIZATIONS
  *****************************************************************************************************************************************/
}
